import { render } from "./FeedOfUser.vue?vue&type=template&id=24358770&scoped=true"
import script from "./FeedOfUser.vue?vue&type=script&lang=js"
export * from "./FeedOfUser.vue?vue&type=script&lang=js"

import "./FeedOfUser.vue?vue&type=style&index=0&id=24358770&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24358770"]])

export default __exports__